module.exports = __webpack_public_path__ + "09a7c9e12bf655a49ec559b7171f5522.svg";